import React, { useEffect, useState } from "react";

import { consultaCatalogosSinPadre } from "app/modules/app-cliente/services/Catalogos/catalogosService";
import { StyleInputs } from "app/modules/common/styles/themes";

import { Field, ErrorMessage } from "formik";

import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";

/**
 * Componente de selección de ítems de catálogos.
 * @param {string} pais - País al que se asocia el catálogo.
 * @param {string} especial - Indicador para un tipo especial de catálogo.
 * @param {string} catalogos - Nombre del catálogo a consultar.
 * @param {string} grupo - Grupo del catálogo a consultar.
 * @param {string} name - Nombre del campo (para Formik).
 * @param {string} label - Etiqueta del campo de selección.
 * @param {Object} componentSize - Ancho del componente en diferentes dispositivos(PC, mobile).
 * @param {function} handleBlur - Función para manejar el evento de desenfoque.
 * @param {Object} touched - Objeto Formik con propiedades `touched`.
 * @param {Object} errors - Objeto Formik con propiedades `errors`.
 * @returns {JSX.Element} Componente Selector.
 */
const SelectItemsCatalogs = ({
  pais,
  especial,
  catalogos,
  grupo,
  name,
  labelName,
  componentSize,
  handleBlur,
  touched,
  errors,
}) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const getData = async () => {
      try {
        const { state, data } = await consultaCatalogosSinPadre(
          especial,
          catalogos,
          grupo
        );

        if (state) {
          setItems(data);
        } else {
          setItems([]);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getData();
  }, []);

  return (
    <FormControl
      sx={StyleInputs(componentSize.pcWidth, componentSize.phoneWidth)}
      id={name}
      name={name}
      error={touched[name] && Boolean(errors[name])}
      helperText={touched[name] && errors[name]}
      onBlur={handleBlur}
    >
      <InputLabel name={name} id={name}>
        {labelName}
      </InputLabel>

      <Field
        id={name}
        as={Select}
        name={name}
        label={labelName}
        autoWidth
        size="small"
        sx={{ minWidth: "100px" }}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {items.map((item) => (
          <MenuItem key={item.codigo} value={item.codigo}>
            {item.descripcion}
          </MenuItem>
        ))}
      </Field>

      <ErrorMessage
        name={name}
        component={() => <FormHelperText>{errors[name]}</FormHelperText>}
      />
    </FormControl>
  );
};

export default SelectItemsCatalogs;
